import React from 'react';
import { education } from '../data/mock';
import { GraduationCap, MapPin } from 'lucide-react';

const Education = () => {
  return (
    <section id="education" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Education & Training
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive medical training from premier institutions across the globe
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-teal-200 hidden md:block"></div>
          
          <div className="space-y-8">
            {education.map((item, index) => (
              <div key={item.id} className="relative">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-32 flex-shrink-0">
                    <div className="inline-block px-4 py-2 bg-teal-700 text-white rounded-lg font-semibold text-sm">
                      {item.year}
                    </div>
                  </div>
                  
                  <div className="relative flex-1">
                    <div className="absolute -left-2 top-2 w-4 h-4 bg-teal-700 rounded-full border-4 border-white hidden md:block"></div>
                    
                    <div className="bg-white border-2 border-teal-100 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                      <div className="flex items-start gap-3 mb-3">
                        <div className="flex-shrink-0 w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                          <GraduationCap className="w-6 h-6 text-teal-700" />
                        </div>
                        <div className="flex-1">
                          <h3 className="text-xl font-bold text-gray-900 mb-1">{item.degree}</h3>
                          <p className="text-teal-700 font-semibold">{item.institution}</p>
                        </div>
                      </div>
                      <p className="text-gray-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;